module.exports = __webpack_public_path__ + "media/v2/person_globe-99e2f0d3.png";